import { SavedWorkflow } from '../types/workflow';
import { API_BASE } from '../config';

export const getAllWorkflows = async (): Promise<SavedWorkflow[]> => {
    const res = await fetch(`${API_BASE}/workflows`);
    if (!res.ok) throw new Error('Failed to fetch workflows');
    return res.json();
};

export const getWorkflowById = async (id: string): Promise<SavedWorkflow | undefined> => {
    const res = await fetch(`${API_BASE}/workflows/${id}`);
    if (res.status === 404) return undefined;
    if (!res.ok) throw new Error('Failed to fetch workflow');
    return res.json();
};

export const createWorkflow = async (data: {
    name: string;
    url: string;
    actions: any[];
    nodes: any[];
    edges: any[];
    variables?: any[];
}): Promise<SavedWorkflow> => {
    const res = await fetch(`${API_BASE}/workflows`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Failed to create workflow');
    return res.json();
};

export const updateWorkflow = async (id: string, data: {
    name: string;
    url: string;
    actions: any[];
    nodes: any[];
    edges: any[];
    variables?: any[];
}): Promise<SavedWorkflow> => {
    const res = await fetch(`${API_BASE}/workflows/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Failed to update workflow');
    return res.json();
};

export const deleteWorkflow = async (id: string): Promise<void> => {
    const res = await fetch(`${API_BASE}/workflows/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to delete workflow');
};

export const exportWorkflowJson = (workflow: SavedWorkflow): object => {
    return {
        url: workflow.url,
        actions: workflow.actions,
    };
};

export const executeWorkflow = async (id: string): Promise<{ executionId: string; status: string; message: string }> => {
    const res = await fetch(`${API_BASE}/workflows/${id}/execute`, { method: 'POST' });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to execute workflow');
    }
    return res.json();
};

export const getExecutionLogs = async (id: string): Promise<any[]> => {
    const res = await fetch(`${API_BASE}/workflows/${id}/executions`);
    if (!res.ok) throw new Error('Failed to fetch execution logs');
    return res.json();
};

export const getLiveLogs = async (executionId: string | number, after: number = 0): Promise<{ logs: any[]; offset: number; status: string; finished: boolean }> => {
    const res = await fetch(`${API_BASE}/workflows/live-logs/${executionId}?after=${after}`);
    if (!res.ok) throw new Error('Failed to fetch live logs');
    return res.json();
};

export const activateWebhook = async (id: string): Promise<void> => {
    const res = await fetch(`${API_BASE}/webhooks/${id}/activate`, { method: 'POST' });
    if (!res.ok) throw new Error('Failed to activate webhook');
};

export const deactivateWebhook = async (id: string): Promise<void> => {
    const res = await fetch(`${API_BASE}/webhooks/${id}/deactivate`, { method: 'POST' });
    if (!res.ok) throw new Error('Failed to deactivate webhook');
};